import React from 'react';
import { Link } from 'react-router-dom';
import plus from 'images/plus.svg';

const AddEventBtn = ({ to, text }) => (
  <Link
    to={to}
    className="inline-flex py-1 px-3 border border-solid border-brandblue text-white bg-brandblue"
  >
    <img src={plus} /> {text}
  </Link>
);

export default AddEventBtn;
